<div *ngIf="isMobile; else webLogin" class="full-container">
  <div class="edit-container">
    <div class="top-content">
      <div class="bid-info-mobile">
        <div class="instruction-mobile">
          Please update your Bid and Submit
        </div>
      </div>
      <div class="form-container-mobile">
        <form [formGroup]="modalForm">
          <div class="bid-form-box">
            <div class="form-group-mobile">
              <div class="form-label-mobile">Enter Number of Units (Kwh)</div>
              <input type="text" inputmode="decimal" id="energy_amount" class="form-control-mobile" appOnlyDecimalNumber formControlName="energy_amount" pattern="^\d+(\.\d{1,2})?$">
              <div *ngIf="energy_amount?.invalid && (energy_amount?.dirty || energy_amount?.touched)">
                <div class="error-mobile" *ngIf="energy_amount?.errors?.['required']">
                  Energy is required.
                </div>
                <div class="error-mobile" *ngIf="!energy_amount?.errors?.['nonNegative'] && energy_amount?.errors?.['min']">
                  Energy must be greater than 0.
                </div>
              </div>
            </div>

            <div class="form-group-mobile">
              <div class="form-label-mobile">Enter Bid rate (Rs.)</div>
              <input type="text" inputmode="decimal" id="bid_price" class="form-control-mobile" appOnlyDecimalNumber formControlName="bid_price" pattern="^\d+(\.\d{1,2})?$">
              <div *ngIf="bid_price?.invalid && (bid_price?.dirty || bid_price?.touched)">
                <div class="error-mobile" *ngIf="bid_price?.errors?.['required']">
                  Bid Price is required.
                </div>
                <div class="error-mobile" *ngIf="!bid_price?.errors?.['nonNegative'] && bid_price?.errors?.['min']">
                  Bid Price must be greater than 0.
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="bottom-content">
      <div class="cancel-and-submit-buttons">
        <div class="cancel-button-mobile">
            <button (click)="onCancel()">Cancel</button>
        </div>
        <div class="submit-button-mobile">
            <button type="submit" (click)="submitBid()" type="submit" [disabled]="!modalForm.valid">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #webLogin>
  <div class="registration-container">
      <div class="form-container">
        <div class="form-header">Update Bid</div>
        <!-- <div *ngIf="isLoading" class="loading-web">
          Updating bid, please wait...
        </div> -->
         <div *ngIf="isLoading" class="loading-web">
          {{ loadingMessage || 'Processing...' }}
        </div>
        <form [formGroup]="modalForm">
          <div class="form-group">
            <div class="form-field">
              <label for="energy_amount">Energy Amount</label>
              <input type="text" inputmode="decimal" id="energy_amount" class="form-control-mobile" appOnlyDecimalNumber formControlName="energy_amount" pattern="^\d+(\.\d{1,2})?$">
              <div *ngIf="energy_amount?.invalid && (energy_amount?.dirty || energy_amount?.touched)">
                <div class="error" *ngIf="energy_amount?.errors?.['required']">
                  Energy is required.
                </div>
                <div class="error" *ngIf="!energy_amount?.errors?.['nonNegative'] && energy_amount?.errors?.['min']">
                  Energy must be greater than 0.
                </div>
              </div>
            </div>
            <div class="form-field">
              <label for="bid_price">Bid Price</label>
              <input type="text" inputmode="decimal" id="bid_price" class="form-control-mobile" appOnlyDecimalNumber formControlName="bid_price" pattern="^\d+(\.\d{1,2})?$">
              <div *ngIf="bid_price?.invalid && (bid_price?.dirty || bid_price?.touched)">
                <div class="error" *ngIf="bid_price?.errors?.['required']">
                  Bid Price is required.
                </div>
                <div class="error" *ngIf="!bid_price?.errors?.['nonNegative'] && bid_price?.errors?.['min']">
                  Bid Price must be greater than 0.
                </div>
              </div>
            </div>
          </div>  
          
        </form>
        <div *ngIf="errorMessage" class="errormsg">
          {{ errorMessage }}
        </div>   
        <div class="form-actions">
          <button type="button" (click)="onCancel()" [disabled]="isLoading">Cancel</button>
          <button (click)="submitBid()" type="submit" [disabled]="!modalForm.valid || isLoading"
          [ngClass]="{'not-allowed': !modalForm.valid, 'pointer': modalForm.valid}">Submit</button>
        </div>
      </div>
    </div>
</ng-template>


















<!-- <div>
  <form [formGroup]="modalForm">
    <mat-form-field>
      <mat-label>Energy Amount</mat-label>
      <input matInput formControlName="energy_amount">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Bid Price</mat-label>
      <input matInput formControlName="bid_price">
    </mat-form-field>
  </form>
</div>
<div>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button (click)="submitBid()" mat-button [disabled]="!modalForm.valid">Submit</button>
</div> -->
